let isLoading = false;

const loadMoreObserver = new IntersectionObserver(async (entries) => {
  const entry = entries[0];
  if (entry.isIntersecting && !isLoading) {
    const btn = entry.target;
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    isLoading = true;
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.getElementById('product-grid');
      const currentGrid = document.getElementById('product-grid');
      
      if (newProducts && currentGrid) {
        const items = newProducts.querySelectorAll(':scope > .grid__item');
        items.forEach(item => currentGrid.appendChild(item));

        const newLoadMoreBtn = doc.querySelector('.load-more-btn');
        if (newLoadMoreBtn && newLoadMoreBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
        } else {
          const wrapper = btn.closest('.load-more-wrapper');
          if (wrapper) wrapper.remove();
          loadMoreObserver.disconnect();
        }
      }
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      isLoading = false;
    }
  }
}, {
  rootMargin: '400px 0px'
});

function initLoadMore() {
  const loadMoreBtn = document.querySelector('.load-more-btn');
  if (loadMoreBtn) {
    loadMoreObserver.observe(loadMoreBtn);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadMore);
} else {
  initLoadMore();
}
